export default {
    admin: 1,
    customer: 2,
    operador: 3,
    aprobador: 4,
    'saas.voucher.reader': 5,
    'saas.voucher.creator': 6,
    coelsa: 7,
    gire: 8,
    globalprocessing: 9,
    cuotitas: 10,
    'admin.cuotitas': 11,
    'admin.digital-origination': 12,
    'seller.digital-origination': 13,
    'manager.lagaceta': 14,
    'seller.lagaceta': 15,
    'admin.lagaceta': 16
};
